import React, { useRef, useState } from "react";
import { Grid, Button, Typography, Chip, Divider } from "@mui/material";
import { Formik, Form } from "formik";
import "react-phone-input-2/lib/style.css";
import "./essential-information-sheet.jsx.css";
import YoungPersonInformation from "./young-person-information";
import SchoolInformation from "./school-information";
import ProfessionalContacts from "./professional-contacts";
import MedicalContacts from "./medical-contacts";
import DistinguishingFeatures from "./distinguishing-features";
import ImportantPeople from "./important-people";
import * as Yup from "yup";

// Define validation schema
const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  dob: Yup.string().required("Date of birth is required"),
  age: Yup.number().required("Age is required").positive().integer(),
  legalStatus: Yup.string().required("Legal Status is required"),
  niNumber: Yup.string().required("NI Number is required"),
  dateTaken: Yup.string().required("Date is required"),
  file: Yup.mixed().required("File is required"),
  parentalResponsibility: Yup.string().required("Parental Responsibility is required"),
  schoolAddress: Yup.string().required("School address is required"),
  headMaster: Yup.string().required("Head Master is required"),
  headOfYear: Yup.string().required("Head Of Year is required"),
  socialWorker: Yup.string().required("Social Worker is required"),
  mobilePhone: Yup.string().required("Mobile phone number is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  yotWorker: Yup.string().required("Yot Worker is required"),
  yotMobilePhone: Yup.string().required("Yot Mobile phone number is required"),
  yotEmail: Yup.string().email("Invalid email format").required("Email is required"),
  gp: Yup.string().required("GP is required"),
  dentist: Yup.string().required("Dentist is required"),
  optician: Yup.string().required("Optician is required"),
  nurse: Yup.string().required("Nurse is required"),
  medicalInformation: Yup.string().required("Medical Information is required"),
  hairColour: Yup.string().required("Hair Colour is required"),
  eyeColour: Yup.string().required("Eye Colour is required"),
  build: Yup.string().required("Build is required"),
  marks: Yup.string().required("Marks is required"),
});

const EssentialInformationSheet = () => {
  const formRef = useRef(null); // Reference to the form DOM
  const [people, setPeople] = useState([]); // State to store list of people
  const [professionals, setProfessionals] = useState([]); // State for the list of professionals
  const [medicals, setMedicals] = useState([]); // State for the list of medicals
  const [features, setFeatures] = useState([]);
  const [contacts, setContacts] = useState([]);

  return (
    <Formik
      initialValues={{
        name: "",
        dob: "",
        age: "",
        legalStatus: "",
        niNumber: "",
        dateTaken: "",
        file: null,
        parentalResponsibility: "",
        schoolAddress: "",
        headMaster: "",
        headOfYear: "",
        personName: "",
        personYear: "",
        socialWorker: "",
        yotWorker: "",
        mobilePhone: "",
        yotMobilePhone: "",
        email: "",
        yotEmail: "",
        gp: "",
        dentist: "",
        optician: "",
        nurse: "",
        medicalInformation: "",
        hairColour: "",
        eyeColour: "",
        build: "",
        marks: "",
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const formData = { ...values, people, professionals, medicals, features, contacts };

        console.log(formData);
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit} ref={formRef} className='admission-form'>
          <Grid item>
            <Chip label={"Admission"} />
          </Grid>
          <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
            Essential Information Sheet
          </Typography>
          <Divider />

          {/* Young Person Information Section */}
          <YoungPersonInformation />

          {/* School Information Section */}
          <SchoolInformation people={people} setPeople={setPeople} />

          {/* Professional Contacts Section */}
          <ProfessionalContacts professionals={professionals} setProfessionals={setProfessionals} />

          {/* Medical Contacts Section */}
          <MedicalContacts medicals={medicals} setMedicals={setMedicals} />

          {/* Distinguishing Features Section */}
          <DistinguishingFeatures setFeatures={setFeatures} />

          {/* Important people Section */}
          <ImportantPeople contacts={contacts} setContacts={setContacts} />

          {/* submit button */}
          <Grid item xs={12} mt={2}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default EssentialInformationSheet;
